/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If AAA is used three times and AAG once (both Lysine), RSCU is 1.5 and 0.5.`)
};

const es_rscu_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si AAA se usa tres veces y AAG una vez (ambos Lisina), el RSCU es 1.5 y 0.5.`)
};

const de_rscu_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn AAA drei Mal und AAG ein Mal verwendet wird (beide Lysin), beträgt RSCU 1,5 bzw. 0,5.`)
};

const nl_rscu_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als AAA drie keer wordt gebruikt en AAG één keer (beide Lysine), is RSCU 1,5 en 0,5.`)
};

const fr_rscu_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si AAA est utilisé trois fois et AAG une fois (tous deux Lysine), le RSCU est 1,5 et 0,5.`)
};

const it_rscu_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se AAA viene usato tre volte e AAG una volta (entrambi lisina), l'RSCU è 1,5 e 0,5.`)
};

const pt_br2_rscu_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se AAA é usado três vezes e AAG uma vez (ambos Lisina), o RSCU é 1,5 e 0,5.`)
};

const pt_rscu_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se AAA for usado três vezes e AAG uma vez (ambos Lisina), o RSCU é 1,5 e 0,5.`)
};

const ja_rscu_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAAが3回、AAGが1回（どちらもリシン）使われる場合、RSCUはそれぞれ1.5と0.5になります。`)
};

const zh_rscu_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果 AAA 使用三次而 AAG 使用一次（均编码赖氨酸），RSCU 分别为 1.5 和 0.5。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_ex2", locale)
	if (locale === "en") return en_rscu_ex2(inputs)
	if (locale === "es") return es_rscu_ex2(inputs)
	if (locale === "de") return de_rscu_ex2(inputs)
	if (locale === "nl") return nl_rscu_ex2(inputs)
	if (locale === "fr") return fr_rscu_ex2(inputs)
	if (locale === "it") return it_rscu_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_ex2(inputs)
	if (locale === "pt") return pt_rscu_ex2(inputs)
	if (locale === "ja") return ja_rscu_ex2(inputs)
	return zh_rscu_ex2(inputs)
};